import React, { useEffect, useState } from "react";
import { FaFileCsv, FaEdit, FaTrash, FaUpload, FaPlus, FaFilter, FaTimes, FaEnvelope, FaCheck, FaDownload, FaBuilding, FaStethoscope, FaVial, FaXRay, FaIdCard } from "react-icons/fa";
import { CSVLink } from "react-csv";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';

const StaffList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const companyId = new URLSearchParams(location.search).get("companyId");

  const [staffs, setStaffs] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [amountToAdd, setAmountToAdd] = useState({
    forTests: "",
    forDoctors: "",
    forPackages: ""
  });
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [loading, setLoading] = useState({
    staff: false,
    diagnostics: false,
    packages: false,
    assignBranch: false,
    tests: false,
    completeData: false,
    bulkUpdateEmployeeId: false,
    exportSelected: false,
    ageGroups: false
  });
  const [updatedStaff, setUpdatedStaff] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  // Test/Assignment Modal States
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);
  const [ageGroups, setAgeGroups] = useState([]);
  const [diagnosticsList, setDiagnosticsList] = useState([]);
  const [selectedDiagnostics, setSelectedDiagnostics] = useState([]);
  const [showDiagnosticDropdown, setShowDiagnosticDropdown] = useState(false);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [selectedScans, setSelectedScans] = useState([]);
  const [applyToAllStaff, setApplyToAllStaff] = useState(false);
  const [showAgeGroupDropdown, setShowAgeGroupDropdown] = useState(false);
  const [assignmentType, setAssignmentType] = useState('packages');

  // Lists State
  const [testsList, setTestsList] = useState([]);
  const [scansList, setScansList] = useState([]);

  // Branch states
  const [branches, setBranches] = useState([]);
  const [loadingBranches, setLoadingBranches] = useState(false);
  const [selectedBranchFilter, setSelectedBranchFilter] = useState("");
  const [showBranchFilter, setShowBranchFilter] = useState(false);

  // Selection states
  const [selectedStaffIds, setSelectedStaffIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Branch Assignment Mode state
  const [branchAssignmentMode, setBranchAssignmentMode] = useState(false);

  // Assign Branch Modal states
  const [showAssignBranchModal, setShowAssignBranchModal] = useState(false);
  const [branchToAssign, setBranchToAssign] = useState("");

  // Export mode state
  const [exportMode, setExportMode] = useState(false);

  // Add Amount Modal state
  const [showAddAmountModal, setShowAddAmountModal] = useState(false);
  const [selectedStaffId, setSelectedStaffId] = useState('');

  const staffsPerPage = 5;

  // Age group options - fetched from API
  const [ageGroupOptions, setAgeGroupOptions] = useState([]);
  const [showAgeGroupManager, setShowAgeGroupManager] = useState(false);
  const [editingAgeGroup, setEditingAgeGroup] = useState(null);
  const [newAgeGroup, setNewAgeGroup] = useState('');

  console.log("ageGroupOptions:", ageGroupOptions)

  // Fetch staff data
  useEffect(() => {
    if (!companyId) return;

    const fetchStaffs = async () => {
      const token = localStorage.getItem("authToken");

      setLoading((prev) => ({ ...prev, staff: true }));

      try {
        const res = await axios.post(
          "https://api.elthiumhealth.com/api/admin/companystaffs",
          { companyId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (res.data?.company?.staff) {
          setStaffs(res.data.company.staff);
        } else {
          setStaffs([]);
        }
      } catch (err) {
        console.error(
          "Error fetching staff data:",
          err.response?.data || err.message
        );

        Swal.fire({
          title: "Error!",
          text: "Failed to load staff data",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading((prev) => ({ ...prev, staff: false }));
      }
    };

    fetchStaffs();
  }, [companyId]);


  const fetchAgeGroups = async () => {
    try {
      setLoading((prev) => ({ ...prev, ageGroups: true }));

      const token = localStorage.getItem("authToken");

      const response = await axios.get(
        "https://api.elthiumhealth.com/api/admin/AgeGroups",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (
        response.data?.success &&
        Array.isArray(response.data.data)
      ) {
        const ageGroupNames = response.data.data.map(
          (item) => item.ageGroup
        );

        console.log("ageGroupNames:", ageGroupNames);
        setAgeGroupOptions(ageGroupNames);
      } else {
        setAgeGroupOptions([
          "0-5",
          "6-12",
          "13-18",
          "19-30",
          "31-45",
          "46-60",
          "61+",
        ]);
      }
    } catch (error) {
      console.error(
        "Error fetching age groups:",
        error.response?.data || error.message
      );

      setAgeGroupOptions([
        "0-5",
        "6-12",
        "13-18",
        "19-30",
        "31-45",
        "46-60",
        "61+",
      ]);
    } finally {
      setLoading((prev) => ({ ...prev, ageGroups: false }));
    }
  };
  // Fetch age groups on component mount
  useEffect(() => {
    fetchAgeGroups();
  }, []);

  // Refresh staff data after email sent
  const refreshStaffData = async () => {
    if (!companyId) return;

    const token = localStorage.getItem("authToken");

    setLoading((prev) => ({ ...prev, staff: true }));

    try {
      const res = await axios.post(
        "https://api.elthiumhealth.com/api/admin/companystaffs",
        { companyId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data?.company?.staff) {
        setStaffs(res.data.company.staff);
      } else {
        setStaffs([]);
      }
    } catch (err) {
      console.error(
        "Error refreshing staff data:",
        err.response?.data || err.message
      );

      Swal.fire({
        title: "Error!",
        text: "Failed to refresh staff data",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading((prev) => ({ ...prev, staff: false }));
    }
  };

  // Fetch complete company staff data for CSV download
  const fetchCompleteStaffData = async () => {
    if (!companyId) {
      Swal.fire({
        title: "Error!",
        text: "Company ID is missing.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return null;
    }

    try {
      setLoading((prev) => ({ ...prev, completeData: true }));

      const token = localStorage.getItem("authToken");

      const response = await axios.post(
        "https://api.elthiumhealth.com/api/admin/companyusers",
        { companyId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (Array.isArray(response.data?.staff)) {
        return response.data.staff;
      }

      Swal.fire({
        title: "Error!",
        text: "Invalid data format received",
        icon: "error",
        confirmButtonText: "OK",
      });

      return null;
    } catch (error) {
      console.error(
        "Error fetching complete staff data:",
        error.response?.data || error.message
      );

      Swal.fire({
        title: "Error!",
        text: "Failed to fetch complete staff data",
        icon: "error",
        confirmButtonText: "OK",
      });

      return null;
    } finally {
      setLoading((prev) => ({ ...prev, completeData: false }));
    }
  };

  // Handle download selected staff for bulk update
  const handleDownloadSelectedForUpdate = async () => {
    if (selectedStaffIds.length === 0) {
      Swal.fire({
        title: 'No Staff Selected!',
        text: 'Please select at least one staff member to export for bulk update.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    try {
      setLoading(prev => ({ ...prev, exportSelected: true }));

      const selectedStaffsData = staffs.filter(staff =>
        selectedStaffIds.includes(staff._id)
      );

      const bulkUpdateData = selectedStaffsData.map(staff => ({
        name: staff.name || '',
        employeeId: staff.employeeId || '',
        email: staff.email || '',
        contact_number: staff.contact_number || '',
        department: staff.department || '',
        role: staff.role || '',
        gender: staff.gender || '',
        dob: staff.dob ? new Date(staff.dob).toISOString().split('T')[0] : '',
        address: staff.address || '',
        age: staff.age || '',
        height: staff.height || '',
        weight: staff.weight || '',
        BP: staff.BP || '',
        BMI: staff.BMI || '',
        eyeSight: staff.eyeSight || ''
      }));

      const bulkUpdateHeaders = [
        { label: "name", key: "name" },
        { label: "employeeId", key: "employeeId" },
        { label: "email", key: "email" },
        { label: "contact_number", key: "contact_number" },
        { label: "department", key: "department" },
        { label: "role", key: "role" },
        { label: "gender", key: "gender" },
        { label: "dob", key: "dob" },
        { label: "address", key: "address" },
        { label: "age", key: "age" },
        { label: "height", key: "height" },
        { label: "weight", key: "weight" },
        { label: "BP", key: "BP" },
        { label: "BMI", key: "BMI" },
        { label: "eyeSight", key: "eyeSight" }
      ];

      let csvContent = '\uFEFF';
      csvContent += bulkUpdateHeaders.map(h => h.label).join(',') + '\n';

      bulkUpdateData.forEach(row => {
        const rowData = bulkUpdateHeaders.map(header => {
          const value = row[header.key] || '';
          return `"${String(value).replace(/"/g, '""')}"`;
        });
        csvContent += rowData.join(',') + '\n';
      });

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `selected_staff_for_update_${selectedStaffIds.length}_records.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Success!',
        html: `
          <div style="text-align: left;">
            <p><strong>Export Successful!</strong></p>
            <p>${selectedStaffIds.length} staff member(s) exported for bulk update.</p>
            <p class="mt-2 text-sm text-gray-600">
              <small><strong>Instructions:</strong></small><br/>
              <small>1. Modify the exported CSV file with new values</small><br/>
              <small>2. Use "Bulk Update Staff" button to upload the modified file</small><br/>
              <small>3. Only "name" field is required for identification</small><br/>
              <small>4. Keep other fields empty if you don't want to update them</small>
            </p>
          </div>
        `,
        icon: 'success',
        confirmButtonText: 'OK',
      });

      setSelectedStaffIds([]);
      setSelectAll(false);
      setExportMode(false);

    } catch (error) {
      console.error("Error exporting selected staff:", error);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to export selected staff data.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setLoading(prev => ({ ...prev, exportSelected: false }));
    }
  };

  // Handle bulk update
  const handleBulkUpdateEmployeeId = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const companyId = new URLSearchParams(location.search).get("companyId");

    if (!companyId) {
      Swal.fire({
        title: "Error!",
        text: "Company ID is missing.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    e.target.value = "";

    Swal.fire({
      title: "Confirm Staff Bulk Update",
      html: `
      <div style="text-align: left;">
        <p><strong>Update staff information from "${file.name}"?</strong></p>
        <p class="text-sm text-gray-600 mt-2">
          <small><strong>CSV Format:</strong></small><br/>
          <small>• <strong>name</strong> (required) - For identification</small><br/>
          <small>• <strong>employeeId</strong> (optional) - Employee ID</small><br/>
          <small>• <strong>email</strong> (optional) - Email address</small><br/>
          <small>• <strong>contact_number</strong> (optional) - Phone number</small><br/>
          <small>• Other fields: department, role, gender, dob, address, age, height, weight, BP, BMI, eyeSight</small>
        </p>
      </div>
    `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Proceed with Update",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("authToken");
        const formData = new FormData();

        formData.append("file", file);
        formData.append("companyId", companyId);

        try {
          setLoading((prev) => ({
            ...prev,
            bulkUpdateEmployeeId: true,
          }));

          const res = await axios.post(
            "https://api.elthiumhealth.com/api/admin/bulk-update-employeeid",
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (res.status === 200) {
            Swal.fire({
              title: "Success!",
              text:
                res.data.message ||
                "Staff information updated successfully!",
              icon: "success",
              confirmButtonText: "OK",
            });

            refreshStaffData();

            if (res.data.results && res.data.results.length > 0) {
              const successCount = res.data.results.filter(
                (r) => r.status === "Updated successfully"
              ).length;

              const skippedCount = res.data.results.filter(
                (r) => r.status.includes("Skipped")
              ).length;

              const notFoundCount = res.data.results.filter(
                (r) => r.status === "Staff Not Found"
              ).length;

              const firstSuccess = res.data.results.find(
                (r) => r.status === "Updated successfully"
              );

              const updatedFields = firstSuccess?.fieldsUpdated || [];

              Swal.fire({
                title: "Update Summary",
                html: `
                <div style="text-align: left;">
                  <p><strong>Total Records:</strong> ${res.data.results.length}</p>
                  <p style="color: green;"><strong>✓ Updated Successfully:</strong> ${successCount}</p>
                  <p style="color: orange;"><strong>⚠ Skipped:</strong> ${skippedCount}</p>
                  <p style="color: red;"><strong>✗ Not Found:</strong> ${notFoundCount}</p>
                  ${updatedFields.length > 0
                    ? `<p><strong>Fields Updated:</strong> ${updatedFields.join(", ")}</p>`
                    : ""
                  }
                </div>
              `,
                icon: "info",
                confirmButtonText: "OK",
              });
            }
          } else {
            Swal.fire({
              title: "Error!",
              text: res.data.message || "Staff update failed.",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } catch (err) {
          console.error(
            "Error updating staff:",
            err.response?.data || err.message
          );

          let errorMessage = "Staff update failed. ";

          if (err.response?.data?.message) {
            errorMessage += err.response.data.message;
          } else if (err.response?.data?.error) {
            errorMessage += err.response.data.error;
          } else {
            errorMessage += "Please check the CSV format.";
          }

          Swal.fire({
            title: "Error!",
            html: `
            <div style="text-align: left;">
              <p>${errorMessage}</p>
              <p class="mt-2 text-sm text-gray-600">
                <small><strong>Required format:</strong><br/>
                • <strong>name</strong> (required) - Staff member's name<br/>
                • <strong>employeeId</strong> (optional) - Employee ID<br/>
                • <strong>email</strong> (optional) - Email address<br/>
                • <strong>contact_number</strong> (optional) - Phone number<br/>
                • Other fields: department, role, gender, dob, address, age, height, weight, BP, BMI, eyeSight</small>
              </p>
            </div>
          `,
            icon: "error",
            confirmButtonText: "OK",
            width: 600,
          });
        } finally {
          setLoading((prev) => ({
            ...prev,
            bulkUpdateEmployeeId: false,
          }));
        }
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Staff update cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };

  // Handle download sample for bulk update
  const handleDownloadBulkUpdateSample = () => {
    Swal.fire({
      title: 'Download Bulk Update Sample',
      text: 'Download sample CSV file for bulk staff updates.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Download Sample',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const sampleHeaders = [
          { label: "name", key: "name" },
          { label: "employeeId", key: "employeeId" },
          { label: "email", key: "email" },
          { label: "contact_number", key: "contact_number" },
          { label: "department", key: "department" },
          { label: "role", key: "role" },
          { label: "gender", key: "gender" },
          { label: "dob", key: "dob" },
          { label: "address", key: "address" },
          { label: "age", key: "age" },
          { label: "height", key: "height" },
          { label: "weight", key: "weight" },
          { label: "BP", key: "BP" },
          { label: "BMI", key: "BMI" },
          { label: "eyeSight", key: "eyeSight" }
        ];

        const sampleData = [
          {
            name: "John Doe",
            employeeId: "EMP001",
            email: "john.doe@example.com",
            contact_number: "9876543210",
            department: "Operations",
            role: "Manager",
            gender: "Male",
            dob: "1990-01-15",
            address: "123 Main Street, City",
            age: "33",
            height: "175",
            weight: "70",
            BP: "120/80",
            BMI: "22.9",
            eyeSight: "6/6"
          },
          {
            name: "Jane Smith",
            employeeId: "EMP002",
            email: "jane.smith@example.com",
            contact_number: "9876543211",
            department: "HR",
            role: "Executive",
            gender: "Female",
            dob: "1992-05-20",
            address: "456 Park Avenue",
            age: "31",
            height: "160",
            weight: "55",
            BP: "110/75",
            BMI: "21.5",
            eyeSight: "6/6"
          }
        ];

        let csvContent = '\uFEFF';
        csvContent += sampleHeaders.map(h => h.label).join(',') + '\n';

        sampleData.forEach(row => {
          const rowData = sampleHeaders.map(header => {
            const value = row[header.key] || '';
            return `"${String(value).replace(/"/g, '""')}"`;
          });
          csvContent += rowData.join(',') + '\n';
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'bulk_update_sample.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Swal.fire({
          title: 'Sample Downloaded!',
          html: `
            <div style="text-align: left;">
              <p>Bulk update sample CSV file has been downloaded.</p>
              <p class="mt-2 text-sm text-gray-600">
                <small><strong>Instructions:</strong></small><br/>
                <small>1. Add staff "name" for identification (required)</small><br/>
                <small>2. Modify other fields as needed</small><br/>
                <small>3. Leave fields empty if you don't want to update them</small><br/>
                <small>4. Upload using "Bulk Update Staff" button</small>
              </p>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'OK',
        });
      }
    });
  };

  // Fetch diagnostics data
  useEffect(() => {
    const fetchDiagnostics = async () => {
      const token = localStorage.getItem("authToken");

      setLoading((prev) => ({ ...prev, diagnostics: true }));

      try {
        const response = await axios.get(
          "https://api.elthiumhealth.com/api/admin/alldiagnostics",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const centers =
          response?.data?.data ||
          response?.data?.diagnostics ||
          [];

        setDiagnosticsList(centers);
      } catch (err) {
        console.error(
          "Error fetching diagnostics:",
          err.response?.data || err.message
        );

        Swal.fire({
          title: "Error!",
          text: "Failed to load diagnostic centers",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading((prev) => ({ ...prev, diagnostics: false }));
      }
    };

    fetchDiagnostics();
  }, []);

  // Extract tests from all selected diagnostics
  useEffect(() => {
    if (selectedDiagnostics.length > 0 && assignmentType === 'tests') {
      const allTests = [];
      selectedDiagnostics.forEach(diagnosticId => {
        const selectedCenter = diagnosticsList.find(d => d._id === diagnosticId);
        if (selectedCenter && selectedCenter.tests) {
          const testsWithDiagnostic = selectedCenter.tests.map(test => ({
            ...test,
            diagnosticId: diagnosticId
          }));
          allTests.push(...testsWithDiagnostic);
        }
      });
      setTestsList(allTests);
    } else {
      setTestsList([]);
    }
  }, [selectedDiagnostics, assignmentType, diagnosticsList]);

  // Extract scans from all selected diagnostics
  useEffect(() => {
    if (selectedDiagnostics.length > 0 && assignmentType === 'scans') {
      const allScans = [];
      selectedDiagnostics.forEach(diagnosticId => {
        const selectedCenter = diagnosticsList.find(d => d._id === diagnosticId);
        if (selectedCenter && selectedCenter.scans) {
          const scansWithDiagnostic = selectedCenter.scans.map(scan => ({
            ...scan,
            diagnosticId: diagnosticId
          }));
          allScans.push(...scansWithDiagnostic);
        }
      });
      setScansList(allScans);
    } else {
      setScansList([]);
    }
  }, [selectedDiagnostics, assignmentType, diagnosticsList]);

  // Fetch branches
  useEffect(() => {
    const fetchBranches = async () => {
      if (!companyId) return;

      try {
        setLoadingBranches(true);

        const token = localStorage.getItem("authToken");

        const response = await axios.post(
          "https://api.elthiumhealth.com/api/admin/singlecompany",
          { companyId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data?.company?.branches) {
          setBranches(response.data.company.branches);
        } else {
          setBranches([]);
        }
      } catch (error) {
        console.error(
          "Error fetching branches:",
          error.response?.data || error.message
        );

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load branches",
        });
      } finally {
        setLoadingBranches(false);
      }
    };

    fetchBranches();
  }, [companyId]);

  // Helper function to get branch name by ID
  const getBranchName = (branchId) => {
    if (!branchId) return 'N/A';
    const branch = branches.find(b => b._id === branchId);
    return branch ? `${branch.branchName} - ${branch.branchCode}` : 'N/A';
  };

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return 'Invalid Date';
    }
  };

  // Filter staffs
  const filteredStaffs = staffs.filter((staff) => {
    if (!staff) return false;

    const searchTerm = search.toLowerCase().trim();

    if (!searchTerm) {
      return selectedBranchFilter ? staff.branch === selectedBranchFilter : true;
    }

    const matchesSearch =
      (staff.name && staff.name.toLowerCase().includes(searchTerm)) ||
      (staff.email && staff.email.toLowerCase().includes(searchTerm)) ||
      (staff.contact_number && staff.contact_number.includes(searchTerm)) ||
      (staff.role && staff.role.toLowerCase().includes(searchTerm)) ||
      (staff.department && staff.department.toLowerCase().includes(searchTerm)) ||
      (staff.userId && staff.userId.toLowerCase().includes(searchTerm)) ||
      (staff.employeeId && staff.employeeId.toLowerCase().includes(searchTerm)) ||
      (staff.address && staff.address.toLowerCase().includes(searchTerm)) ||
      (getBranchName(staff.branch).toLowerCase().includes(searchTerm));

    const matchesBranch = selectedBranchFilter ? staff.branch === selectedBranchFilter : true;

    return matchesSearch && matchesBranch;
  });

  const staffWithoutBranch = filteredStaffs.filter(staff => !staff.branch);

  const indexOfLast = currentPage * staffsPerPage;
  const indexOfFirst = indexOfLast - staffsPerPage;
  const currentStaffs = filteredStaffs.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredStaffs.length / staffsPerPage);

  const handlePageChange = (page) => setCurrentPage(page);
  const nextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  // CSV Headers
  const headers = [
    { label: "Employee ID", key: "employeeId" },
    { label: "Name", key: "name" },
    { label: "Role", key: "role" },
    { label: "Department", key: "department" },
    { label: "Contact Number", key: "contact_number" },
    { label: "Email", key: "email" },
    { label: "DOB", key: "dob" },
    { label: "Gender", key: "gender" },
    { label: "Age", key: "age" },
    { label: "Address", key: "address" },
    { label: "Wallet Amount", key: "wallet_balance" },
    { label: "Branch", key: "branchName" },
    { label: "Mail Sent", key: "mailSent" },
    { label: "Mail Sent At", key: "mailSentAt" },
  ];

  const staffsWithBranchNames = filteredStaffs.map(staff => ({
    ...staff,
    employeeId: staff.employeeId || 'N/A',
    branchName: getBranchName(staff.branch),
    mailSent: staff.mailSent ? 'Yes' : 'No',
    mailSentAt: staff.mailSentAt ? formatDate(staff.mailSentAt) : 'N/A'
  }));

  // Handle branch filter change
  const handleBranchFilterChange = (branchId) => {
    setSelectedBranchFilter(branchId);
    setCurrentPage(1);
    setShowBranchFilter(false);
  };

  // Clear branch filter
  const clearBranchFilter = () => {
    setSelectedBranchFilter("");
    setCurrentPage(1);
  };

  // Handle age group selection
  const handleAgeGroupChange = (ageGroup) => {
    if (ageGroups.includes(ageGroup)) {
      setAgeGroups(ageGroups.filter(ag => ag !== ageGroup));
    } else {
      setAgeGroups([...ageGroups, ageGroup]);
    }
  };

  // Remove age group
  const removeAgeGroup = (ageGroupToRemove) => {
    setAgeGroups(ageGroups.filter(ag => ag !== ageGroupToRemove));
  };

  // Select all age groups
  const selectAllAgeGroups = () => {
    setAgeGroups([...ageGroupOptions]);
  };

  // Clear all age groups
  const clearAllAgeGroups = () => {
    setAgeGroups([]);
  };

  // Handle individual staff selection
  const handleStaffSelection = (staffId, mailSent) => {
    if (!branchAssignmentMode && mailSent && !exportMode) {
      return;
    }

    if (selectedStaffIds.includes(staffId)) {
      setSelectedStaffIds(selectedStaffIds.filter(id => id !== staffId));
    } else {
      setSelectedStaffIds([...selectedStaffIds, staffId]);
    }
  };

  // Handle select all
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStaffIds([]);
    } else {
      let allSelectableStaffIds;

      if (branchAssignmentMode) {
        allSelectableStaffIds = filteredStaffs.map(staff => staff._id);
      } else if (exportMode) {
        allSelectableStaffIds = filteredStaffs.map(staff => staff._id);
      } else {
        allSelectableStaffIds = filteredStaffs.filter(staff => !staff.mailSent).map(staff => staff._id);
      }
      setSelectedStaffIds(allSelectableStaffIds);
    }
    setSelectAll(!selectAll);
  };

  // Enable Branch Assignment Mode
  const enableBranchAssignmentMode = () => {
    if (branches.length === 0) {
      Swal.fire({
        title: 'No Branches Available!',
        text: 'Please add branches first before assigning.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    setSelectedStaffIds([]);
    setSelectAll(false);
    setBranchAssignmentMode(true);
    setExportMode(false);

    Swal.fire({
      title: 'Branch Assignment Mode Enabled',
      text: 'You can now select staff members to assign branches.',
      icon: 'info',
      confirmButtonText: 'OK',
    });
  };

  // Disable Branch Assignment Mode
  const disableBranchAssignmentMode = () => {
    setBranchAssignmentMode(false);
    setSelectedStaffIds([]);
    setSelectAll(false);
  };

  // Enable Export Mode
  const enableExportMode = () => {
    setExportMode(true);
    setBranchAssignmentMode(false);
    setSelectedStaffIds([]);
    setSelectAll(false);

    Swal.fire({
      title: 'Export Mode Enabled',
      html: `
        <div style="text-align: left;">
          <p>You can now select staff members to export for bulk update.</p>
          <p class="mt-2 text-sm text-gray-600">
            <small><strong>How it works:</strong></small><br/>
            <small>1. Select staff members (checkboxes)</small><br/>
            <small>2. Click "Export Selected for Update" button</small><br/>
            <small>3. Modify the exported CSV file</small><br/>
            <small>4. Upload modified file using "Bulk Update Staff" button</small>
          </p>
        </div>
      `,
      icon: 'info',
      confirmButtonText: 'OK',
    });
  };

  // Disable Export Mode
  const disableExportMode = () => {
    setExportMode(false);
    setSelectedStaffIds([]);
    setSelectAll(false);
  };

  // Open assign branch modal for selected staff
  const openAssignBranchModalForSelected = () => {
    if (selectedStaffIds.length === 0) {
      Swal.fire({
        title: 'No Staff Selected!',
        text: 'Please select at least one staff member to assign branch.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (branches.length === 0) {
      Swal.fire({
        title: 'No Branches Available!',
        text: 'Please add branches first before assigning.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    setShowAssignBranchModal(true);
  };

  // Close assign branch modal
  const closeAssignBranchModal = () => {
    setShowAssignBranchModal(false);
    setBranchToAssign("");
    disableBranchAssignmentMode();
  };

  // Handle branch assignment
  const handleAssignBranch = async () => {
    if (!branchToAssign) {
      Swal.fire({
        title: "Branch Required!",
        text: "Please select a branch to assign.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const { isConfirmed } = await Swal.fire({
      title: "Assign Branch?",
      text: `Are you sure you want to assign ${getBranchName(
        branchToAssign
      )} to ${selectedStaffIds.length} staff member(s)?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Assign!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!isConfirmed) return;

    try {
      setLoading((prev) => ({ ...prev, assignBranch: true }));

      const token = localStorage.getItem("authToken");

      const response = await axios.put(
        "https://api.elthiumhealth.com/api/admin/update-branches",
        {
          staffIds: selectedStaffIds,
          companyId,
          branch: branchToAssign,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setStaffs((prev) =>
          prev.map((staff) => {
            if (selectedStaffIds.includes(staff._id)) {
              return { ...staff, branch: branchToAssign };
            }
            return staff;
          })
        );

        setSelectedStaffIds([]);
        setSelectAll(false);
        closeAssignBranchModal();

        Swal.fire({
          title: "Success!",
          text: `Branch assigned successfully to ${response.data.updatedCount || selectedStaffIds.length
            } staff member(s)!`,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error(
        "Error assigning branch:",
        error.response?.data || error.message
      );

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to assign branch.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading((prev) => ({ ...prev, assignBranch: false }));
    }
  };

  // Email sending function
  const handleSendEmail = async () => {
    if (selectedStaffIds.length === 0) {
      Swal.fire({
        title: "No Users Selected!",
        text: "Please select at least one user to send email.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const staffToSendEmail = staffs.filter(
      (staff) =>
        selectedStaffIds.includes(staff._id) && !staff.mailSent
    );

    if (staffToSendEmail.length === 0) {
      Swal.fire({
        title: "No Eligible Users!",
        text: "Selected users already have emails sent.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const { isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: `Send login credentials email to ${staffToSendEmail.length} user(s)?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Send Email!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!isConfirmed) return;

    try {
      const token = localStorage.getItem("authToken");

      const response = await axios.post(
        "https://api.elthiumhealth.com/api/admin/send-bulk-email",
        {
          staffIds: staffToSendEmail.map((staff) => staff._id),
          companyId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Success!",
          text: `Email sent to ${staffToSendEmail.length} user(s)!`,
          icon: "success",
          confirmButtonText: "OK",
        });

        setSelectedStaffIds([]);
        setSelectAll(false);
        refreshStaffData();
      }
    } catch (error) {
      console.error(
        "Error sending email:",
        error.response?.data || error.message
      );

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to send email.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // Download sample CSV for staff import
  const handleDownloadSample = () => {
    Swal.fire({
      title: 'Download Sample CSV',
      text: 'Download the sample CSV file for bulk import.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Download Sample',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const sampleHeaders = [
          { label: "Employee ID", key: "employeeId" },
          { label: "Name", key: "name" },
          { label: "Role", key: "role" },
          { label: "Department", key: "department" },
          { label: "Contact Number", key: "contact_number" },
          { label: "Email", key: "email" },
          { label: "DOB (YYYY-MM-DD)", key: "dob" },
          { label: "Gender", key: "gender" },
          { label: "Age", key: "age" },
          { label: "Address", key: "address" },
          { label: "Password", key: "password" },
          { label: "Branch ID (Optional)", key: "branch" }
        ];

        const sampleData = [
          {
            name: "John Doe",
            role: "Manager",
            department: "Operations",
            contact_number: "9876543210",
            email: "john.doe@example.com",
            dob: "1990-01-15",
            gender: "Male",
            age: "33",
            address: "123 Main Street, City, State",
            password: "password123",
            employeeId: "EMP001",
            branch: ""
          }
        ];

        let csvContent = '\uFEFF';
        csvContent += sampleHeaders.map(h => h.label).join(',') + '\n';

        sampleData.forEach(row => {
          const rowData = sampleHeaders.map(header => {
            const value = row[header.key] || '';
            return `"${String(value).replace(/"/g, '""')}"`;
          });
          csvContent += rowData.join(',') + '\n';
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'staff_import_sample.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Swal.fire({
          title: 'Sample Downloaded!',
          text: 'Sample CSV file has been downloaded.',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      }
    });
  };

  // Handle download complete company staff data
  const handleDownloadCompleteData = async () => {
    const completeStaffData = await fetchCompleteStaffData();

    if (!completeStaffData || completeStaffData.length === 0) {
      Swal.fire({
        title: 'No Data!',
        text: 'No staff data available for download.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    const completeHeaders = [
      { label: "Employee ID", key: "employeeId" },
      { label: "Name", key: "name" },
      { label: "Email", key: "email" },
      { label: "Gender", key: "gender" },
      { label: "Department", key: "department" },
      { label: "Age", key: "age" },
      { label: "Role", key: "role" },
      { label: "Contact Number", key: "contact_number" },
      { label: "Height", key: "height" },
      { label: "Weight", key: "weight" },
      { label: "BP", key: "BP" },
      { label: "BMI", key: "BMI" },
      { label: "Eye Checkup Results", key: "eyeCheckupResults" },
      { label: "Eye Sight", key: "eyeSight" },
      { label: "Profile Image", key: "profileImage" },
      { label: "ID Image", key: "idImage" },
      { label: "Password", key: "password" }
    ];

    const processedData = completeStaffData.map(staff => ({
      employeeId: staff.employeeId || '',
      name: staff.name || '',
      email: staff.email || '',
      gender: staff.gender || '',
      department: staff.department || '',
      age: staff.age || '',
      role: staff.role || '',
      contact_number: staff.contact_number || '',
      height: staff.height || '',
      weight: staff.weight || '',
      BP: staff.BP || '',
      BMI: staff.BMI || '',
      eyeCheckupResults: staff.eyeCheckupResults || '',
      eyeSight: staff.eyeSight || '',
      profileImage: staff.profileImage || '',
      idImage: staff.idImage || '',
      password: staff.password || ''
    }));

    let csvContent = '\uFEFF';
    csvContent += completeHeaders.map(h => h.label).join(',') + '\n';

    processedData.forEach(row => {
      const rowData = completeHeaders.map(header => {
        const value = row[header.key] || '';
        return `"${String(value).replace(/"/g, '""')}"`;
      });
      csvContent += rowData.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `complete_staff_data_company_${companyId}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    Swal.fire({
      title: 'Success!',
      text: `Complete staff data downloaded (${completeStaffData.length} records)`,
      icon: 'success',
      confirmButtonText: 'OK',
    });
  };

  const handleBulkImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const companyId = new URLSearchParams(location.search).get("companyId");

    if (!companyId) {
      Swal.fire({
        title: "Error!",
        text: "Company ID is missing.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    e.target.value = "";

    Swal.fire({
      title: "Confirm Import",
      text: `Import staff from "${file.name}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Proceed",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("authToken");
        const formData = new FormData();

        formData.append("file", file);
        formData.append("companyId", companyId);

        try {
          const res = await fetch(
            "https://api.elthiumhealth.com/api/admin/import-staffs",
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: formData,
            }
          );

          const responseData = await res.json();

          if (res.ok) {
            const newStaff = Array.isArray(responseData.data)
              ? responseData.data.filter((staff) => staff != null)
              : responseData.data
                ? [responseData.data]
                : [];

            Swal.fire({
              title: "Success!",
              text: "Staff imported successfully!",
              icon: "success",
              confirmButtonText: "OK",
            });

            setStaffs((prev) => [
              ...prev.filter((staff) => staff != null),
              ...newStaff,
            ]);
          } else {
            Swal.fire({
              title: "Error!",
              text: responseData.error || "Import failed.",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } catch (err) {
          console.error("Error importing staff:", err);

          Swal.fire({
            title: "Error!",
            text: "Upload failed.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Import cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };

  const handleEdit = (staff) => {
    setSelectedStaff(staff);
    setUpdatedStaff({
      ...staff,
      branch: staff.branch || ''
    });
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    const { isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "Delete this staff? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!isConfirmed) return;

    try {
      const token = localStorage.getItem("authToken");

      const res = await axios.delete(
        "https://api.elthiumhealth.com/api/admin/deletestaff",
        {
          data: { staffId: id },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 200) {
        setStaffs((prev) => prev.filter((s) => s._id !== id));
        setSelectedStaffIds((prev) =>
          prev.filter((staffId) => staffId !== id)
        );

        Swal.fire({
          title: "Deleted!",
          text: "Staff deleted successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to delete staff.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error(
        "Error deleting staff:",
        err.response?.data || err.message
      );

      Swal.fire({
        title: "Error!",
        text: "Error deleting staff.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // Open Add Amount Modal
  const openAddAmountModal = () => {
    setShowAddAmountModal(true);
    setAmountToAdd({ forTests: '', forDoctors: '', forPackages: '' });
  };

  // Close Add Amount Modal
  const closeAddAmountModal = () => {
    setShowAddAmountModal(false);
    setAmountToAdd({ forTests: '', forDoctors: '', forPackages: '' });
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setSelectedStaff(null);
  };

  const closeAssignmentModal = () => {
    setShowAssignmentModal(false);
    setSelectedDiagnostics([]);
    setSelectedPackages([]);
    setSelectedTests([]);
    setSelectedScans([]);
    setAgeGroups([]);
    setShowAgeGroupDropdown(false);
    setAssignmentType('packages');
    setShowDiagnosticDropdown(false);
  };

  const handleAddAmount = async () => {
    const forTests = parseFloat(amountToAdd.forTests || 0);
    const forDoctors = parseFloat(amountToAdd.forDoctors || 0);
    const forPackages = parseFloat(amountToAdd.forPackages || 0);

    const total = forTests + forDoctors + forPackages;

    if (total <= 0) {
      Swal.fire("Error!", "Please enter amount greater than zero", "error");
      return;
    }

    if (!selectedStaffIds || selectedStaffIds.length === 0) {
      Swal.fire(
        "No Staff Selected!",
        "Please select at least one staff member.",
        "warning"
      );
      return;
    }

    try {
      setLoading((prev) => ({ ...prev, packages: true }));

      const confirm = await Swal.fire({
        title: `Add Amount to ${selectedStaffIds.length} Staff?`,
        text: `Total: ₹${total.toFixed(2)} × ${selectedStaffIds.length} staff = ₹${(
          total * selectedStaffIds.length
        ).toFixed(2)}`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Add Amount",
        cancelButtonText: "Cancel",
      });

      if (!confirm.isConfirmed) return;

      const token = localStorage.getItem("authToken");

      const response = await axios.post(
        "https://api.elthiumhealth.com/api/admin/add-amount-to-all",
        {
          companyId,
          staffIds: selectedStaffIds,
          forTests,
          forDoctors,
          forPackages,
          from: "Admin",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API Response:", response.data);

      if (response.data.success) {
        const { summary } = response.data;

        Swal.fire(
          "Success!",
          `Amount added to ${summary.updatedCount} staff members.${summary.failedCount > 0
            ? ` ${summary.failedCount} failed.`
            : ""
          }`,
          "success"
        );
      } else {
        throw new Error(response.data.message || "Failed to add amount");
      }

      closeAddAmountModal();
      refreshStaffData();
    } catch (error) {
      console.error(
        "Error adding amount:",
        error.response?.data || error.message
      );

      Swal.fire(
        "Error!",
        error.response?.data?.message ||
        error.message ||
        "Failed to add amount",
        "error"
      );
    } finally {
      setLoading((prev) => ({ ...prev, packages: false }));
    }
  };


  const handleSubmitEdit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("authToken");

      const res = await axios.put(
        "https://api.elthiumhealth.com/api/admin/editstaff",
        {
          staffId: selectedStaff._id,
          ...updatedStaff,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 200) {
        const updated = res.data.updatedStaff;

        setStaffs((prev) =>
          prev.map((s) =>
            s._id === updated._id ? { ...s, ...updated } : s
          )
        );

        closeEditModal();

        Swal.fire({
          title: "Success!",
          text: "Staff updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Update failed.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error(
        "Error updating staff:",
        err.response?.data || err.message
      );

      Swal.fire({
        title: "Error!",
        text: "Error updating staff.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleViewHistory = (staffId) => {
    navigate(`/staff-history/${staffId}`);
  };

  // Handle diagnostic toggle for multi-select
  const handleDiagnosticToggle = (diagnosticId) => {
    if (selectedDiagnostics.includes(diagnosticId)) {
      setSelectedDiagnostics(selectedDiagnostics.filter(id => id !== diagnosticId));
      // Remove items from this diagnostic
      if (assignmentType === 'packages') {
        const diagnostic = diagnosticsList.find(d => d._id === diagnosticId);
        if (diagnostic && diagnostic.packages) {
          const packageIds = diagnostic.packages.map(p => `${diagnosticId}_${p._id}`);
          setSelectedPackages(prev => prev.filter(id => !packageIds.includes(id)));
        }
      } else if (assignmentType === 'tests') {
        const diagnosticTests = testsList.filter(t => t.diagnosticId === diagnosticId);
        const testIds = diagnosticTests.map(t => `${diagnosticId}_${t._id}`);
        setSelectedTests(prev => prev.filter(id => !testIds.includes(id)));
      } else if (assignmentType === 'scans') {
        const diagnosticScans = scansList.filter(s => s.diagnosticId === diagnosticId);
        const scanIds = diagnosticScans.map(s => `${diagnosticId}_${s._id}`);
        setSelectedScans(prev => prev.filter(id => !scanIds.includes(id)));
      }
    } else {
      setSelectedDiagnostics([...selectedDiagnostics, diagnosticId]);
    }
  };

  // Handle package selection with diagnostic ID
  const handlePackageChange = (e, diagnosticId) => {
    const value = e.target.value;
    const uniqueKey = `${diagnosticId}_${value}`;

    if (selectedPackages.includes(uniqueKey)) {
      setSelectedPackages(selectedPackages.filter((id) => id !== uniqueKey));
    } else {
      setSelectedPackages([...selectedPackages, uniqueKey]);
    }
  };

  // Handle test selection with diagnostic ID
  const handleTestChange = (e, diagnosticId) => {
    const value = e.target.value;
    const uniqueKey = `${diagnosticId}_${value}`;

    if (selectedTests.includes(uniqueKey)) {
      setSelectedTests(selectedTests.filter((id) => id !== uniqueKey));
    } else {
      setSelectedTests([...selectedTests, uniqueKey]);
    }
  };

  // Handle scan selection with diagnostic ID
  const handleScanChange = (e, diagnosticId) => {
    const value = e.target.value;
    const uniqueKey = `${diagnosticId}_${value}`;

    if (selectedScans.includes(uniqueKey)) {
      setSelectedScans(selectedScans.filter((id) => id !== uniqueKey));
    } else {
      setSelectedScans([...selectedScans, uniqueKey]);
    }
  };

  // Select all packages from all selected diagnostics
  const handleSelectAllPackages = (e) => {
    if (e.target.checked) {
      const allPackageIds = [];
      selectedDiagnostics.forEach(diagnosticId => {
        const diagnostic = diagnosticsList.find(d => d._id === diagnosticId);
        if (diagnostic && diagnostic.packages) {
          diagnostic.packages.forEach(pkg => {
            const uniqueKey = `${diagnosticId}_${pkg._id}`;
            if (!allPackageIds.includes(uniqueKey)) {
              allPackageIds.push(uniqueKey);
            }
          });
        }
      });
      setSelectedPackages(allPackageIds);
    } else {
      setSelectedPackages([]);
    }
  };

  // Select all tests from all selected diagnostics
  const handleSelectAllTests = (e) => {
    if (e.target.checked) {
      const allTestIds = [];
      selectedDiagnostics.forEach(diagnosticId => {
        const diagnosticTests = testsList.filter(t => t.diagnosticId === diagnosticId);
        diagnosticTests.forEach(test => {
          const uniqueKey = `${diagnosticId}_${test._id}`;
          if (!allTestIds.includes(uniqueKey)) {
            allTestIds.push(uniqueKey);
          }
        });
      });
      setSelectedTests(allTestIds);
    } else {
      setSelectedTests([]);
    }
  };

  // Select all scans from all selected diagnostics
  const handleSelectAllScans = (e) => {
    if (e.target.checked) {
      const allScanIds = [];
      selectedDiagnostics.forEach(diagnosticId => {
        const diagnosticScans = scansList.filter(s => s.diagnosticId === diagnosticId);
        diagnosticScans.forEach(scan => {
          const uniqueKey = `${diagnosticId}_${scan._id}`;
          if (!allScanIds.includes(uniqueKey)) {
            allScanIds.push(uniqueKey);
          }
        });
      });
      setSelectedScans(allScanIds);
    } else {
      setSelectedScans([]);
    }
  };

  // Check if all packages are selected
  const allPackagesSelected = () => {
    let totalPackages = 0;
    let selectedCount = 0;

    selectedDiagnostics.forEach(diagnosticId => {
      const diagnostic = diagnosticsList.find(d => d._id === diagnosticId);
      if (diagnostic && diagnostic.packages) {
        diagnostic.packages.forEach(pkg => {
          totalPackages++;
          const uniqueKey = `${diagnosticId}_${pkg._id}`;
          if (selectedPackages.includes(uniqueKey)) {
            selectedCount++;
          }
        });
      }
    });

    return totalPackages > 0 && selectedCount === totalPackages;
  };

  // Check if all tests are selected
  const allTestsSelected = () => {
    let totalTests = 0;
    let selectedCount = 0;

    selectedDiagnostics.forEach(diagnosticId => {
      const diagnosticTests = testsList.filter(t => t.diagnosticId === diagnosticId);
      diagnosticTests.forEach(test => {
        totalTests++;
        const uniqueKey = `${diagnosticId}_${test._id}`;
        if (selectedTests.includes(uniqueKey)) {
          selectedCount++;
        }
      });
    });

    return totalTests > 0 && selectedCount === totalTests;
  };

  // Check if all scans are selected
  const allScansSelected = () => {
    let totalScans = 0;
    let selectedCount = 0;

    selectedDiagnostics.forEach(diagnosticId => {
      const diagnosticScans = scansList.filter(s => s.diagnosticId === diagnosticId);
      diagnosticScans.forEach(scan => {
        totalScans++;
        const uniqueKey = `${diagnosticId}_${scan._id}`;
        if (selectedScans.includes(uniqueKey)) {
          selectedCount++;
        }
      });
    });

    return totalScans > 0 && selectedCount === totalScans;
  };

  // Get selected items count by diagnostic
  const getDiagnosticSelectedCount = (diagnosticId, type) => {
    let count = 0;
    if (type === 'packages') {
      const diagnostic = diagnosticsList.find(d => d._id === diagnosticId);
      if (diagnostic && diagnostic.packages) {
        diagnostic.packages.forEach(pkg => {
          if (selectedPackages.includes(`${diagnosticId}_${pkg._id}`)) count++;
        });
      }
    } else if (type === 'tests') {
      const diagnosticTests = testsList.filter(t => t.diagnosticId === diagnosticId);
      diagnosticTests.forEach(test => {
        if (selectedTests.includes(`${diagnosticId}_${test._id}`)) count++;
      });
    } else if (type === 'scans') {
      const diagnosticScans = scansList.filter(s => s.diagnosticId === diagnosticId);
      diagnosticScans.forEach(scan => {
        if (selectedScans.includes(`${diagnosticId}_${scan._id}`)) count++;
      });
    }
    return count;
  };

  // Handle assignment with multiple diagnostics
  const handleAssignment = async (e) => {
    e.preventDefault();
    setLoading((prev) => ({ ...prev, packages: true }));

    const companyId = new URLSearchParams(location.search).get("companyId");

    if (!companyId) {
      Swal.fire({
        title: "Error!",
        text: "Company ID is required. Please access this page from company management.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading((prev) => ({ ...prev, packages: false }));
      return;
    }

    if (!applyToAllStaff && ageGroups.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please select age groups or choose apply to all staff.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading((prev) => ({ ...prev, packages: false }));
      return;
    }

    if (selectedDiagnostics.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please select at least one diagnostic center.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading((prev) => ({ ...prev, packages: false }));
      return;
    }

    if (assignmentType === "packages" && selectedPackages.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please select at least one package from any diagnostic center.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading((prev) => ({ ...prev, packages: false }));
      return;
    }

    if (assignmentType === "tests" && selectedTests.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please select at least one test from any diagnostic center.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading((prev) => ({ ...prev, packages: false }));
      return;
    }

    if (assignmentType === "scans" && selectedScans.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please select at least one scan from any diagnostic center.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading((prev) => ({ ...prev, packages: false }));
      return;
    }

    let payload = {};
    let endpoint = "";
    const diagnosticsMap = {};

    if (assignmentType === "packages") {
      endpoint = "https://api.elthiumhealth.com/api/admin/add-packages";

      selectedPackages.forEach((uniqueKey) => {
        const [diagnosticId, packageId] = uniqueKey.split("_");

        if (selectedDiagnostics.includes(diagnosticId)) {
          if (!diagnosticsMap[diagnosticId]) {
            diagnosticsMap[diagnosticId] = [];
          }

          diagnosticsMap[diagnosticId].push(packageId);
        }
      });

      const diagnosticsData = Object.keys(diagnosticsMap).map(
        (diagnosticId) => ({
          diagnosticId,
          packageIds: diagnosticsMap[diagnosticId],
        })
      );

      payload = {
        companyId,
        applyToAllStaff,
        ageGroup: applyToAllStaff ? null : ageGroups.join(","),
        diagnostics: diagnosticsData,
      };
    } else if (assignmentType === "tests") {
      endpoint = "https://api.elthiumhealth.com/api/admin/add-tests";

      selectedTests.forEach((uniqueKey) => {
        const [diagnosticId, testId] = uniqueKey.split("_");
        const test = testsList.find((t) => t._id === testId);

        if (selectedDiagnostics.includes(diagnosticId) && test) {
          if (!diagnosticsMap[diagnosticId]) {
            diagnosticsMap[diagnosticId] = [];
          }

          diagnosticsMap[diagnosticId].push({
            testId: test._id,
            testName: test.name,
          });
        }
      });

      const diagnosticsData = Object.keys(diagnosticsMap).map(
        (diagnosticId) => ({
          diagnosticId,
          testIds: diagnosticsMap[diagnosticId],
        })
      );

      payload = {
        companyId,
        applyToAllStaff,
        ageGroup: applyToAllStaff ? null : ageGroups.join(","),
        diagnostics: diagnosticsData,
      };
    } else if (assignmentType === "scans") {
      endpoint = "https://api.elthiumhealth.com/api/admin/add-scans";

      selectedScans.forEach((uniqueKey) => {
        const [diagnosticId, scanId] = uniqueKey.split("_");
        const scan = scansList.find((s) => s._id === scanId);

        if (selectedDiagnostics.includes(diagnosticId) && scan) {
          if (!diagnosticsMap[diagnosticId]) {
            diagnosticsMap[diagnosticId] = [];
          }

          diagnosticsMap[diagnosticId].push({
            scanId: scan._id,
            scanTitle: scan.title,
            preparation: scan.preparation || "",
            reportTime: scan.reportTime || "",
          });
        }
      });

      const diagnosticsData = Object.keys(diagnosticsMap).map(
        (diagnosticId) => ({
          diagnosticId,
          scanIds: diagnosticsMap[diagnosticId],
        })
      );

      payload = {
        companyId,
        applyToAllStaff,
        ageGroup: applyToAllStaff ? null : ageGroups.join(","),
        diagnostics: diagnosticsData,
      };
    }

    console.log(
      "Sending payload with multiple diagnostics:",
      JSON.stringify(payload, null, 2)
    );

    try {
      const token = localStorage.getItem("authToken");

      const response = await axios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        title: "Success!",
        text: `${assignmentType.charAt(0).toUpperCase() + assignmentType.slice(1)
          } assigned successfully to staff and company from ${Object.keys(diagnosticsMap).length
          } diagnostic center(s)!`,
        icon: "success",
        confirmButtonText: "OK",
      });

      setSelectedDiagnostics([]);
      setSelectedPackages([]);
      setSelectedTests([]);
      setSelectedScans([]);
      setAgeGroups([]);
      setApplyToAllStaff(false);
      setShowDiagnosticDropdown(false);
    } catch (error) {
      console.error(
        "Error in assignment:",
        error.response?.data || error.message
      );

      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message ||
          `Failed to assign ${assignmentType}. Please try again.`,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading((prev) => ({ ...prev, packages: false }));
    }
  };

  // Age group manager functions with API integration
  const handleSaveAgeGroup = async () => {
    try {
      const ageGroupValue = editingAgeGroup || newAgeGroup;

      if (!ageGroupValue) {
        Swal.fire({
          title: "Error!",
          text: "Please enter an age group.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      setLoading((prev) => ({ ...prev, ageGroups: true }));

      const token = localStorage.getItem("authToken");

      if (editingAgeGroup) {
        // Fetch existing age groups
        const response = await axios.get(
          "https://api.elthiumhealth.com/api/admin/AgeGroups",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data?.success && Array.isArray(response.data.data)) {
          // Find the age group being edited
          const ageGroupItem = response.data.data.find(
            (item) => item.ageGroup === editingAgeGroup
          );

          if (!ageGroupItem) {
            throw new Error("Age group not found.");
          }

          await axios.put(
            "https://api.elthiumhealth.com/api/admin/AgeGroups",
            {
              ageGroupId: ageGroupItem._id,
              ageGroup: ageGroupValue,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
        }

        setEditingAgeGroup(null);
      } else {
        // Add a new age group
        await axios.post(
          "https://api.elthiumhealth.com/api/admin/AgeGroups",
          {
            ageGroups: [ageGroupValue],
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      }

      // Refresh age groups
      await fetchAgeGroups();
      setNewAgeGroup("");

      Swal.fire({
        title: "Success!",
        text: `Age group "${ageGroupValue}" ${editingAgeGroup ? "updated" : "added"
          } successfully!`,
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error(
        "Error saving age group:",
        error.response?.data || error.message
      );

      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message ||
          error.message ||
          "Failed to save age group.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading((prev) => ({ ...prev, ageGroups: false }));
    }
  };

  const handleEditAgeGroup = (ageGroup) => {
    setEditingAgeGroup(ageGroup);
    setNewAgeGroup(ageGroup);
    // Close the age group manager to show the edit field
    setShowAgeGroupManager(false);
    // Reopen with edit mode
    setTimeout(() => setShowAgeGroupManager(true), 100);
  };

  const handleDeleteAgeGroup = async (ageGroup) => {
    const { isConfirmed } = await Swal.fire({
      title: "Delete Age Group?",
      text: `Are you sure you want to delete "${ageGroup}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!isConfirmed) return;

    try {
      setLoading((prev) => ({ ...prev, ageGroups: true }));

      const token = localStorage.getItem("authToken");

      // Fetch existing age groups
      const response = await axios.get(
        "https://api.elthiumhealth.com/api/admin/AgeGroups",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.success && Array.isArray(response.data.data)) {
        const ageGroupItem = response.data.data.find(
          (item) => item.ageGroup === ageGroup
        );

        if (!ageGroupItem) {
          throw new Error("Age group not found.");
        }

        // Delete using the ID in the request body
        await axios.delete(
          "https://api.elthiumhealth.com/api/admin/AgeGroups",
          {
            data: { ageGroupId: ageGroupItem._id },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        throw new Error("Failed to retrieve age groups.");
      }

      // Refresh age groups
      await fetchAgeGroups();

      // Remove from selected age groups if present
      setAgeGroups((prev) => prev.filter((ag) => ag !== ageGroup));

      Swal.fire({
        title: "Deleted!",
        text: `Age group "${ageGroup}" deleted successfully!`,
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error(
        "Error deleting age group:",
        error.response?.data || error.message
      );

      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message ||
          error.message ||
          "Failed to delete age group.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading((prev) => ({ ...prev, ageGroups: false }));
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">User List</h2>
        <button
          onClick={() => setShowAssignmentModal(true)}
          className="px-4 py-2 bg-blue-600 text-white rounded flex items-center gap-2"
          disabled={loading.packages}
        >
          <FaPlus /> Add Packages/Tests/Scans
        </button>
      </div>

      {/* Selection Actions Bar */}
      {selectedStaffIds.length > 0 && (
        <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded flex justify-between items-center">
          <div className="flex items-center gap-4">
            <span className="font-semibold text-blue-800">
              {selectedStaffIds.length} user(s) selected
            </span>
            {branchAssignmentMode && (
              <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded-full text-xs">
                Branch Assignment Mode
              </span>
            )}
            {exportMode && (
              <span className="px-2 py-1 bg-teal-100 text-teal-800 rounded-full text-xs">
                Export Mode
              </span>
            )}
          </div>
          <div className="flex gap-2">
            {branchAssignmentMode ? (
              <>
                <button
                  onClick={openAssignBranchModalForSelected}
                  className="px-4 py-2 bg-gray-200 text-black rounded flex items-center gap-2 text-sm shadow-sm hover:bg-gray-300"
                >
                  <FaBuilding className="text-black" /> Assign Branch to Selected
                </button>
                <button
                  onClick={disableBranchAssignmentMode}
                  className="px-4 py-2 bg-gray-500 text-white rounded text-sm"
                >
                  Cancel
                </button>
              </>
            ) : exportMode ? (
              <>
                <button
                  onClick={handleDownloadSelectedForUpdate}
                  disabled={loading.exportSelected}
                  className="px-4 py-2 bg-teal-600 text-white rounded flex items-center gap-2 text-sm"
                >
                  {loading.exportSelected ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Exporting...
                    </>
                  ) : (
                    <>
                      <FaDownload /> Export Selected for Update
                    </>
                  )}
                </button>
                <button
                  onClick={disableExportMode}
                  className="px-4 py-2 bg-gray-500 text-white rounded text-sm"
                >
                  Cancel
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={handleSendEmail}
                  className="px-4 py-2 bg-green-600 text-white rounded flex items-center gap-2 text-sm"
                  disabled={selectedStaffIds.some(id => {
                    const staff = staffs.find(s => s._id === id);
                    return staff?.mailSent;
                  })}
                >
                  <FaEnvelope /> Send Email
                </button>
                <button
                  onClick={() => {
                    setSelectedStaffIds([]);
                    setSelectAll(false);
                  }}
                  className="px-4 py-2 bg-gray-500 text-white rounded text-sm"
                >
                  Clear Selection
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Mode Indicators */}
      {branchAssignmentMode && selectedStaffIds.length === 0 && (
        <div className="mb-4 p-3 bg-purple-50 border border-purple-200 rounded flex justify-between items-center">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-purple-800">
              Branch Assignment Mode: Select staff to assign branches
            </span>
          </div>
          <button
            onClick={disableBranchAssignmentMode}
            className="px-3 py-1 bg-gray-500 text-white rounded text-sm"
          >
            Exit Mode
          </button>
        </div>
      )}

      {exportMode && selectedStaffIds.length === 0 && (
        <div className="mb-4 p-3 bg-teal-50 border border-teal-200 rounded flex justify-between items-center">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-teal-800">
              Export Mode: Select staff to export for bulk update
            </span>
          </div>
          <button
            onClick={disableExportMode}
            className="px-3 py-1 bg-gray-500 text-white rounded text-sm"
          >
            Exit Mode
          </button>
        </div>
      )}

      <div className="mb-4 flex flex-wrap gap-2">
        <input
          type="text"
          className="px-3 py-2 border rounded text-sm flex-1 min-w-[250px]"
          placeholder="Search by name, email, contact, role, department, employee ID, branch..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
        />

        {!branchAssignmentMode && !exportMode ? (
          <>
            <button
              onClick={enableBranchAssignmentMode}
              className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 shadow-sm hover:bg-gray-300"
              title="Enable branch assignment mode"
            >
              <FaBuilding className="text-black" /> Add Branch
            </button>
            <button
              onClick={enableExportMode}
              className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 shadow-sm hover:bg-gray-300"
              title="Enable export mode for bulk updates"
            >
              <FaDownload className="text-black" /> Export for Update
            </button>
          </>
        ) : branchAssignmentMode ? (
          <button
            onClick={disableBranchAssignmentMode}
            className="px-4 py-2 bg-red-500 text-white rounded text-sm flex items-center gap-2"
          >
            <FaTimes /> Exit Branch Mode
          </button>
        ) : (
          <button
            onClick={disableExportMode}
            className="px-4 py-2 bg-red-500 text-white rounded text-sm flex items-center gap-2"
          >
            <FaTimes /> Exit Export Mode
          </button>
        )}

        {/* Branch Filter Dropdown */}
        <div className="relative">
          <button
            onClick={() => setShowBranchFilter(!showBranchFilter)}
            className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 hover:bg-gray-300"
          >
            <FaFilter className="text-black" /> Branch Filter
            {selectedBranchFilter && (
              <span className="ml-1 bg-white text-black rounded-full w-5 h-5 flex items-center justify-center text-xs">
                ✓
              </span>
            )}
          </button>

          {showBranchFilter && (
            <div className="absolute top-full left-0 mt-1 w-64 bg-white border rounded shadow-lg z-10 max-h-60 overflow-y-auto">
              <div className="p-2 border-b">
                <div className="flex justify-between items-center">
                  <span className="font-medium text-sm">Filter by Branch</span>
                  {selectedBranchFilter && (
                    <button
                      onClick={clearBranchFilter}
                      className="text-xs text-blue-600 hover:text-blue-800"
                    >
                      Clear
                    </button>
                  )}
                </div>
              </div>
              <div className="max-h-48 overflow-y-auto">
                <button
                  onClick={() => handleBranchFilterChange("")}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 ${!selectedBranchFilter ? "bg-blue-50 text-blue-600" : ""
                    }`}
                >
                  All Branches
                </button>
                {branches.map((branch) => (
                  <button
                    key={branch._id}
                    onClick={() => handleBranchFilterChange(branch._id)}
                    className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 ${selectedBranchFilter === branch._id ? "bg-blue-50 text-blue-600" : ""
                      }`}
                  >
                    {branch.branchName} - {branch.branchCode}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Show active filter badge */}
        {selectedBranchFilter && (
          <div className="flex items-center gap-2 px-3 py-1 bg-blue-100 text-blue-800 rounded text-sm">
            <span>Branch: {getBranchName(selectedBranchFilter)}</span>
            <button
              onClick={clearBranchFilter}
              className="text-blue-600 hover:text-blue-800 text-xs"
            >
              ✕
            </button>
          </div>
        )}

        <CSVLink
          data={staffsWithBranchNames}
          headers={headers}
          filename="staff_list.csv"
          className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 hover:bg-gray-300"
        >
          <FaFileCsv className="text-black" /> Export CSV
        </CSVLink>

        {/* Download Complete Company Staff Data Button */}
        <button
          onClick={handleDownloadCompleteData}
          disabled={loading.completeData}
          className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 hover:bg-gray-300"
        >
          {loading.completeData ? (
            <>
              <svg className="animate-spin h-4 w-4 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Loading...
            </>
          ) : (
            <>
              <FaDownload className="text-black" /> Complete Data CSV
            </>
          )}
        </button>

        {/* Download Sample CSV Button for Staff Import */}
        <button
          onClick={handleDownloadSample}
          className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 hover:bg-gray-300"
        >
          <FaDownload className="text-black" /> Sample CSV
        </button>

        {/* Bulk Update Sample Button */}
        <button
          onClick={handleDownloadBulkUpdateSample}
          className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 hover:bg-gray-300"
        >
          <FaDownload className="text-black" /> Bulk Update Sample
        </button>

        <button
          onClick={openAddAmountModal}
          className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 hover:bg-gray-300"
        >
          <FaPlus className="text-black" /> Add Amount to Staff
        </button>

        {/* Bulk Update Staff Button */}
        <label
          htmlFor="bulk-update-employeeid"
          className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 cursor-pointer hover:bg-gray-300"
          title="Bulk update staff information using CSV file"
        >
          {loading.bulkUpdateEmployeeId ? (
            <>
              <svg className="animate-spin h-4 w-4 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Updating...
            </>
          ) : (
            <>
              <FaIdCard className="text-black" /> Bulk Update Staff
            </>
          )}
          <input
            type="file"
            accept=".csv"
            id="bulk-update-employeeid"
            onChange={handleBulkUpdateEmployeeId}
            className="hidden"
            disabled={loading.bulkUpdateEmployeeId}
          />
        </label>

        {/* Bulk Import Button for Staff Import */}
        <label
          htmlFor="import-file"
          className="px-4 py-2 bg-gray-200 text-black rounded text-sm flex items-center gap-2 cursor-pointer shadow-sm hover:bg-gray-300"
        >
          <FaUpload className="text-black" /> Bulk Import Staff
          <input
            type="file"
            accept=".xlsx, .xls, .csv"
            id="import-file"
            onChange={handleBulkImport}
            className="hidden"
          />
        </label>
      </div>

      {/* Filter Summary */}
      <div className="mb-3 p-2 bg-gray-50 border border-gray-200 rounded text-sm flex justify-between items-center">
        <div>
          <strong>Results:</strong> Showing {filteredStaffs.length} of {staffs.length} staff members
          {selectedBranchFilter && (
            <span className="ml-2">
              in branch: <span className="font-semibold text-blue-600">{getBranchName(selectedBranchFilter)}</span>
            </span>
          )}
          {staffWithoutBranch.length > 0 && (
            <span className="ml-2">
              | <span className="font-semibold text-amber-600">{staffWithoutBranch.length} without branch</span>
            </span>
          )}
          {search && (
            <span className="ml-2">
              matching: <span className="font-semibold text-green-600">"{search}"</span>
            </span>
          )}
        </div>
        {(search || selectedBranchFilter) && (
          <button
            onClick={() => {
              setSearch("");
              clearBranchFilter();
            }}
            className="px-2 py-1 bg-gray-200 text-gray-700 rounded text-xs hover:bg-gray-300"
          >
            Clear All Filters
          </button>
        )}
      </div>

      {loading.staff ? (
        <div className="text-center py-8">Loading staff data...</div>
      ) : filteredStaffs.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No staff members found. {search && 'Try changing your search criteria.'}
        </div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full border rounded text-xs">
              <thead className="bg-gray-200">
                <tr>
                  <th className="p-1 border w-10">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      className="h-3 w-3 text-blue-600 rounded"
                    />
                  </th>
                  <th className="p-1 border">Employee ID</th>
                  <th className="p-1 border">Name</th>
                  <th className="p-1 border">Role</th>
                  <th className="p-1 border">Department</th>
                  <th className="p-1 border">Contact</th>
                  <th className="p-1 border">Email</th>
                  <th className="p-1 border">Address</th>
                  <th className="p-1 border">Age</th>
                  <th className="p-1 border">Branch</th>
                  <th className="p-1 border">Mail Sent</th>
                  <th className="p-1 border">Sent At</th>
                  <th className="p-1 border">Terms Accepted</th>
                  <th className="p-1 border">Add</th>
                  <th className="p-1 border">Actions</th>
                  <th className="p-1 border">History</th>
                  <th className="p-1 border">User PKGS</th>
                </tr>
              </thead>
              <tbody>
                {currentStaffs.map((staff) => (
                  staff && (
                    <tr key={staff._id} className="hover:bg-gray-100">
                      <td className="p-1 border text-center">
                        <input
                          type="checkbox"
                          checked={selectedStaffIds.includes(staff._id)}
                          onChange={() => handleStaffSelection(staff._id, staff.mailSent)}
                          disabled={!branchAssignmentMode && staff.mailSent && !exportMode}
                          className={`h-3 w-3 rounded ${(!branchAssignmentMode && staff.mailSent && !exportMode)
                            ? 'bg-gray-200 cursor-not-allowed'
                            : 'text-blue-600 cursor-pointer'
                            }`}
                        />
                      </td>
                      <td className="p-1 border">{staff.employeeId || 'N/A'}</td>
                      <td className="p-1 border">{staff.name || 'N/A'}</td>
                      <td className="p-1 border">{staff.role || 'N/A'}</td>
                      <td className="p-1 border">{staff.department || 'N/A'}</td>
                      <td className="p-1 border">{staff.contact_number || 'N/A'}</td>
                      <td className="p-1 border truncate max-w-[120px]">{staff.email || 'N/A'}</td>
                      <td className="p-1 border truncate max-w-[100px]">{staff.address || 'N/A'}</td>
                      <td className="p-1 border">{staff.age || 'N/A'}</td>
                      <td className="p-1 border truncate max-w-[100px]">
                        <div className="flex items-center justify-between">
                          <span className={!staff.branch ? "text-red-600 font-semibold" : ""}>
                            {getBranchName(staff.branch)}
                          </span>
                          {!staff.branch && (
                            <span className="text-xs text-amber-600 ml-1" title="No branch assigned">⚠</span>
                          )}
                        </div>
                      </td>

                      <td className="p-1 border text-center">
                        {staff.mailSent ? (
                          <span className="inline-flex items-center gap-0.5 px-1 py-0.5 bg-green-100 text-green-800 rounded-full text-xs">
                            <FaCheck className="text-green-600 text-xs" />
                            Sent
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-0.5 px-1 py-0.5 bg-red-100 text-red-800 rounded-full text-xs">
                            <FaTimes className="text-red-600 text-xs" />
                            Pending
                          </span>
                        )}
                      </td>

                      <td className="p-1 border text-xs">
                        {staff.mailSentAt ? formatDate(staff.mailSentAt) : 'N/A'}
                      </td>

                      <td className="p-1 border">
                        {staff.termsAndConditionsAccepted ? (
                          <div className="flex flex-col items-center">
                            <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-green-100 text-green-800 rounded-full text-xs mb-1">
                              <FaCheck className="text-green-600 text-xs" />
                              Accepted
                            </span>
                            {staff.termsAcceptedAt && (
                              <span className="text-[10px] text-gray-600">
                                {formatDate(staff.termsAcceptedAt)}
                              </span>
                            )}
                          </div>
                        ) : (
                          <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-red-100 text-red-800 rounded-full text-xs">
                            <FaTimes className="text-red-600 text-xs" />
                            Not Accepted
                          </span>
                        )}
                      </td>

                      <td className="p-1 border">
                        <button
                          onClick={() => openAddAmountModal(staff)}
                          className="bg-blue-500 text-white px-1 py-0.5 rounded text-xs"
                        >
                          Add Amount
                        </button>
                      </td>
                      <td className="p-1 border flex justify-center gap-1">
                        <button
                          onClick={() => handleEdit(staff)}
                          className="text-blue-600 text-xs hover:text-blue-800"
                          title="Edit"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDelete(staff._id)}
                          className="text-red-600 text-xs hover:text-red-800"
                          title="Delete"
                        >
                          <FaTrash />
                        </button>
                      </td>
                      <td className="p-1 border">
                        <button
                          onClick={() => handleViewHistory(staff._id)}
                          className="bg-indigo-500 text-white px-1 py-0.5 rounded text-xs hover:bg-indigo-600"
                        >
                          View
                        </button>
                      </td>
                      <td className="p-1 border text-center">
                        <button className="bg-blue-600 text-white px-2 py-0.5 rounded hover:bg-blue-700 transition duration-200 text-xs">
                          <Link to={`/stafftestpkg/${staff._id}`}>
                            View
                          </Link>
                        </button>
                      </td>
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </div>

          {filteredStaffs.length > staffsPerPage && (
            <div className="mt-4 flex justify-center items-center gap-2">
              <button
                onClick={prevPage}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded disabled:opacity-50 hover:bg-gray-100"
              >
                Prev
              </button>

              <select
                value={currentPage}
                onChange={(e) => setCurrentPage(Number(e.target.value))}
                className="px-2 py-1 border rounded text-sm"
              >
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <option key={page} value={page}>
                    Page {page}
                  </option>
                ))}
              </select>

              <span className="px-3 py-1 text-sm">
                of {totalPages}
              </span>

              <button
                onClick={nextPage}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded disabled:opacity-50 hover:bg-gray-100"
              >
                Next
              </button>
            </div>
          )}
        </>
      )}

      {/* Add Amount Modal */}
      {showAddAmountModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-[500px] max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Add Amount to Selected Staff</h3>
              <button
                onClick={closeAddAmountModal}
                className="text-gray-500 hover:text-gray-700"
                disabled={loading.packages}
              >
                ✕
              </button>
            </div>

            <div className="mb-6">
              <div className="flex justify-between items-center mb-3">
                <label className="block text-sm font-medium text-gray-700">
                  Select Staff ({selectedStaffIds.length} selected)
                </label>
                <div className="flex gap-2">
                  <button
                    onClick={() => setSelectedStaffIds(staffs.map(staff => staff._id))}
                    className="text-xs px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded border"
                    type="button"
                    disabled={loading.packages || staffs.length === 0}
                  >
                    Select All
                  </button>
                  <button
                    onClick={() => setSelectedStaffIds([])}
                    className="text-xs px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded border"
                    type="button"
                    disabled={loading.packages}
                  >
                    Clear All
                  </button>
                </div>
              </div>

              <div className="border rounded p-3 max-h-60 overflow-y-auto bg-gray-50">
                {staffs.length === 0 ? (
                  <p className="text-gray-500 text-center py-4">No staff available</p>
                ) : (
                  <div className="space-y-2">
                    {staffs.map((staff) => (
                      <div key={staff._id} className="flex items-center p-2 hover:bg-white rounded border-b">
                        <input
                          type="checkbox"
                          id={`staff-${staff._id}`}
                          checked={selectedStaffIds.includes(staff._id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedStaffIds([...selectedStaffIds, staff._id]);
                            } else {
                              setSelectedStaffIds(selectedStaffIds.filter(id => id !== staff._id));
                            }
                          }}
                          className="h-4 w-4 text-blue-600 rounded"
                          disabled={loading.packages}
                        />
                        <label
                          htmlFor={`staff-${staff._id}`}
                          className="ml-3 flex-1 cursor-pointer"
                        >
                          <div className="font-medium flex items-center">
                            {staff.name}
                            {staff.employeeId && (
                              <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded">
                                {staff.employeeId}
                              </span>
                            )}
                          </div>
                          {staff.designation && (
                            <div className="text-sm text-gray-500">{staff.designation}</div>
                          )}
                          {staff.wallet_balance !== undefined && (
                            <div className="text-xs text-green-600 font-medium mt-1">
                              Current Balance: ₹{staff.wallet_balance?.toFixed(2) || '0.00'}
                            </div>
                          )}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="space-y-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">For Tests (₹)</label>
                <input
                  type="number"
                  className="w-full border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter amount"
                  value={amountToAdd.forTests}
                  onChange={(e) => setAmountToAdd({ ...amountToAdd, forTests: e.target.value })}
                  disabled={loading.packages}
                  min="0"
                  step="0.01"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">For Doctors (₹)</label>
                <input
                  type="number"
                  className="w-full border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter amount"
                  value={amountToAdd.forDoctors}
                  onChange={(e) => setAmountToAdd({ ...amountToAdd, forDoctors: e.target.value })}
                  disabled={loading.packages}
                  min="0"
                  step="0.01"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">For Packages (₹)</label>
                <input
                  type="number"
                  className="w-full border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter amount"
                  value={amountToAdd.forPackages}
                  onChange={(e) => setAmountToAdd({ ...amountToAdd, forPackages: e.target.value })}
                  disabled={loading.packages}
                  min="0"
                  step="0.01"
                />
              </div>

              {selectedStaffIds.length > 0 && (
                <div className="p-3 bg-blue-50 rounded border border-blue-200">
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <span className="text-sm text-gray-600">Per Staff Total:</span>
                      <p className="text-lg font-bold text-blue-700">
                        ₹{(
                          parseFloat(amountToAdd.forTests || 0) +
                          parseFloat(amountToAdd.forDoctors || 0) +
                          parseFloat(amountToAdd.forPackages || 0)
                        ).toFixed(2)}
                      </p>
                    </div>
                    <div>
                      <span className="text-sm text-gray-600">Grand Total:</span>
                      <p className="text-lg font-bold text-green-700">
                        ₹{(
                          (parseFloat(amountToAdd.forTests || 0) +
                            parseFloat(amountToAdd.forDoctors || 0) +
                            parseFloat(amountToAdd.forPackages || 0)) *
                          selectedStaffIds.length
                        ).toFixed(2)}
                      </p>
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 mt-2">
                    For {selectedStaffIds.length} selected staff member{selectedStaffIds.length !== 1 ? 's' : ''}
                  </p>
                </div>
              )}
            </div>

            <div className="flex flex-col gap-3">
              <button
                onClick={() => handleAddAmount()}
                disabled={loading.packages || selectedStaffIds.length === 0}
                className="w-full px-4 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-colors"
              >
                {loading.packages ? (
                  <>
                    <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
                    Adding...
                  </>
                ) : (
                  `Add Amount to Selected (${selectedStaffIds.length})`
                )}
              </button>
            </div>

            <div className="mt-4 text-center">
              <button
                onClick={closeAddAmountModal}
                className="text-sm text-gray-600 hover:text-gray-800 px-4 py-2 hover:bg-gray-100 rounded transition-colors"
                disabled={loading.packages}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-[400px] max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">Edit User</h3>
            <form onSubmit={handleSubmitEdit} className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Employee ID</label>
                <input
                  type="text"
                  className="w-full border p-2 rounded"
                  placeholder="Employee ID"
                  value={updatedStaff.employeeId || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, employeeId: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                  type="text"
                  className="w-full border p-2 rounded"
                  placeholder="Name"
                  value={updatedStaff.name || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, name: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                <input
                  type="text"
                  className="w-full border p-2 rounded"
                  placeholder="Role"
                  value={updatedStaff.role || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, role: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Department</label>
                <input
                  type="text"
                  className="w-full border p-2 rounded"
                  placeholder="Department"
                  value={updatedStaff.department || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, department: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Contact Number</label>
                <input
                  type="text"
                  className="w-full border p-2 rounded"
                  placeholder="Contact Number"
                  value={updatedStaff.contact_number || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, contact_number: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  className="w-full border p-2 rounded"
                  placeholder="Email"
                  value={updatedStaff.email || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, email: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth</label>
                <input
                  type="date"
                  className="w-full border p-2 rounded"
                  placeholder="DOB"
                  value={updatedStaff.dob || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, dob: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
                <select
                  className="w-full border p-2 rounded"
                  value={updatedStaff.gender || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, gender: e.target.value })}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Age</label>
                <input
                  type="number"
                  className="w-full border p-2 rounded"
                  placeholder="Age"
                  value={updatedStaff.age || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, age: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                <input
                  type="text"
                  className="w-full border p-2 rounded"
                  placeholder="Address"
                  value={updatedStaff.address || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, address: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Branch</label>
                <select
                  className="w-full border p-2 rounded"
                  value={updatedStaff.branch || ""}
                  onChange={(e) => setUpdatedStaff({ ...updatedStaff, branch: e.target.value })}
                >
                  <option value="">Select Branch</option>
                  {branches.map((branch) => (
                    <option key={branch._id} value={branch._id}>
                      {branch.branchName} - {branch.branchCode}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex justify-end gap-2 pt-2">
                <button
                  type="button"
                  onClick={closeEditModal}
                  className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Assign Branch Modal */}
      {showAssignBranchModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-[400px]">
            <h3 className="text-lg font-semibold mb-4">Assign Branch</h3>

            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded">
              <p className="text-sm">
                <strong>Selected Staff:</strong> {selectedStaffIds.length} staff member(s)
              </p>
            </div>

            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Select Branch <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border p-2 rounded"
                  value={branchToAssign}
                  onChange={(e) => setBranchToAssign(e.target.value)}
                >
                  <option value="">-- Select Branch --</option>
                  {branches.map((branch) => (
                    <option key={branch._id} value={branch._id}>
                      {branch.branchName} - {branch.branchCode}
                    </option>
                  ))}
                </select>
              </div>

              {branchToAssign && (
                <div className="p-3 bg-green-50 border border-green-200 rounded">
                  <p className="text-sm">
                    <strong>Selected Branch:</strong> {getBranchName(branchToAssign)}
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={closeAssignBranchModal}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                disabled={loading.assignBranch}
              >
                Cancel
              </button>
              <button
                onClick={handleAssignBranch}
                disabled={!branchToAssign || loading.assignBranch}
                className="px-4 py-2 bg-gray-200 text-black rounded hover:bg-gray-300 disabled:opacity-50 shadow-sm"
              >
                {loading.assignBranch ? "Assigning..." : "Assign Branch"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Assignment Modal with Multiple Diagnostics and Selection Summary */}
      {showAssignmentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[800px] max-w-5xl relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={closeAssignmentModal}
              className="absolute top-2 right-2 text-red-500 hover:text-red-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <h3 className="text-xl font-semibold mb-4 text-center text-gray-800">
              Add Packages/Tests/Scans
            </h3>

            {/* Assignment Type Toggle */}
            <div className="mb-6 flex justify-center">
              <div className="inline-flex rounded-lg border border-gray-300 overflow-hidden">
                <button
                  type="button"
                  onClick={() => {
                    setAssignmentType('packages');
                    setSelectedTests([]);
                    setSelectedScans([]);
                  }}
                  className={`px-6 py-2 text-sm font-medium flex items-center gap-2 ${assignmentType === 'packages'
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                >
                  <FaStethoscope /> Packages
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setAssignmentType('tests');
                    setSelectedPackages([]);
                    setSelectedScans([]);
                  }}
                  className={`px-6 py-2 text-sm font-medium flex items-center gap-2 ${assignmentType === 'tests'
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                >
                  <FaVial /> Tests
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setAssignmentType('scans');
                    setSelectedPackages([]);
                    setSelectedTests([]);
                  }}
                  className={`px-6 py-2 text-sm font-medium flex items-center gap-2 ${assignmentType === 'scans'
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                >
                  <FaXRay /> Scans
                </button>
              </div>
            </div>

            <form onSubmit={handleAssignment} className="space-y-4">
              {/* Diagnostic Center Selection - Multiple */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Diagnostic Centers <span className="text-red-500">*</span>
                </label>

                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setShowDiagnosticDropdown(!showDiagnosticDropdown)}
                    className="w-full border p-2 rounded-lg text-sm text-left bg-white flex justify-between items-center"
                  >
                    <span>
                      {selectedDiagnostics.length === 0
                        ? "Select Diagnostic Centers"
                        : `${selectedDiagnostics.length} center(s) selected`}
                    </span>
                    <span className={`transform transition-transform ${showDiagnosticDropdown ? 'rotate-180' : ''}`}>
                      ▼
                    </span>
                  </button>

                  {showDiagnosticDropdown && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white border rounded-lg shadow-lg z-10 max-h-60 overflow-y-auto">
                      <div className="p-2 border-b bg-gray-50 flex justify-between items-center">
                        <span className="text-sm font-medium">Select Diagnostic Centers</span>
                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() => {
                              const allIds = diagnosticsList.map(d => d._id);
                              setSelectedDiagnostics(allIds);
                            }}
                            className="text-xs text-blue-600 hover:text-blue-800"
                          >
                            Select All
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedDiagnostics([]);
                              setSelectedPackages([]);
                              setSelectedTests([]);
                              setSelectedScans([]);
                            }}
                            className="text-xs text-red-600 hover:text-red-800"
                          >
                            Clear All
                          </button>
                        </div>
                      </div>
                      <div className="max-h-48 overflow-y-auto">
                        {diagnosticsList.map((diagnostic) => (
                          <label
                            key={diagnostic._id}
                            className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer border-b"
                          >
                            <input
                              type="checkbox"
                              checked={selectedDiagnostics.includes(diagnostic._id)}
                              onChange={() => handleDiagnosticToggle(diagnostic._id)}
                              className="accent-blue-600"
                            />
                            <span className="text-sm">{diagnostic.name}</span>
                            <span className="text-xs text-gray-500 ml-auto">
                              {diagnostic.packages?.length || 0} packages
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Show selected diagnostics summary */}
                {selectedDiagnostics.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-1">
                    {selectedDiagnostics.map(id => {
                      const diagnostic = diagnosticsList.find(d => d._id === id);
                      return diagnostic ? (
                        <span key={id} className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                          {diagnostic.name}
                          <span className="text-xs text-blue-600 ml-1">
                            ({getDiagnosticSelectedCount(id, assignmentType)} selected)
                          </span>
                          <button
                            type="button"
                            onClick={() => handleDiagnosticToggle(id)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <FaTimes size={10} />
                          </button>
                        </span>
                      ) : null;
                    })}
                  </div>
                )}
              </div>

              {/* Packages Selection - Grouped by Diagnostic Center */}
              {selectedDiagnostics.length > 0 && assignmentType === 'packages' && (
                <div className="mb-4">
                  <label className="block text-sm mb-2 text-gray-700">
                    Select Packages from Selected Centers
                  </label>

                  <label className="inline-flex items-center mb-2 cursor-pointer select-none">
                    <input
                      type="checkbox"
                      checked={allPackagesSelected()}
                      onChange={handleSelectAllPackages}
                      className="mr-2 accent-purple-900"
                    />
                    <span className="text-sm font-medium">Select All Packages</span>
                    <span className="text-xs text-gray-500 ml-2">
                      ({selectedPackages.length} selected)
                    </span>
                  </label>

                  {loading.packages ? (
                    <div className="grid grid-cols-2 gap-4">
                      {[1, 2].map((i) => (
                        <div key={i} className="p-4 bg-gray-100 rounded border animate-pulse h-24"></div>
                      ))}
                    </div>
                  ) : (
                    <div className="border rounded p-2 bg-gray-50 max-h-80 overflow-y-auto">
                      {selectedDiagnostics.map(diagnosticId => {
                        const diagnostic = diagnosticsList.find(d => d._id === diagnosticId);
                        if (!diagnostic || !diagnostic.packages || diagnostic.packages.length === 0) {
                          return (
                            <div key={diagnosticId} className="p-2 text-gray-500 text-sm">
                              No packages available for {diagnostic?.name || 'Unknown'}
                            </div>
                          );
                        }

                        const selectedCount = getDiagnosticSelectedCount(diagnosticId, 'packages');

                        return (
                          <div key={diagnosticId} className="mb-4 border-b border-gray-200 pb-3 last:border-b-0">
                            <div className="font-medium text-sm text-blue-700 mb-2 flex items-center gap-2">
                              <span>{diagnostic.name}</span>
                              <span className="text-xs text-gray-500">
                                ({selectedCount}/{diagnostic.packages.length} selected)
                              </span>
                            </div>
                            <div className="flex flex-wrap gap-3">
                              {diagnostic.packages.map((pkg) => {
                                const uniqueKey = `${diagnosticId}_${pkg._id}`;
                                const isSelected = selectedPackages.includes(uniqueKey);
                                return (
                                  <label
                                    key={pkg._id}
                                    className={`inline-flex items-start whitespace-normal px-3 py-2 border rounded shadow-sm min-w-[180px] cursor-pointer hover:bg-gray-50 ${isSelected ? 'bg-blue-50 border-blue-400' : 'bg-white'
                                      }`}
                                  >
                                    <input
                                      type="checkbox"
                                      value={pkg._id}
                                      checked={isSelected}
                                      onChange={(e) => handlePackageChange(e, diagnosticId)}
                                      className="mr-2 mt-1 accent-purple-900"
                                    />
                                    <div>
                                      <div className="font-semibold text-sm">
                                        {pkg.name}
                                      </div>
                                      <div className="text-xs text-gray-600">
                                        Tests: {pkg.totalTestsIncluded || pkg.includedTests?.length || 0}
                                      </div>
                                      {pkg.offerPrice && (
                                        <div className="text-xs text-green-600">
                                          ₹{pkg.offerPrice}
                                        </div>
                                      )}
                                    </div>
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {/* Tests Selection - Grouped by Diagnostic Center */}
              {selectedDiagnostics.length > 0 && assignmentType === 'tests' && (
                <div className="mb-4">
                  <label className="block text-sm mb-2 text-gray-700">
                    Select Tests from Selected Centers
                  </label>

                  {testsList.length === 0 ? (
                    <div className="text-center p-4 text-gray-500 border rounded">
                      No tests available for the selected diagnostic centers.
                    </div>
                  ) : (
                    <>
                      <label className="inline-flex items-center mb-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={allTestsSelected()}
                          onChange={handleSelectAllTests}
                          className="mr-2 accent-purple-900"
                        />
                        <span className="text-sm font-medium">Select All Tests</span>
                        <span className="text-xs text-gray-500 ml-2">
                          ({selectedTests.length} selected)
                        </span>
                      </label>

                      <div className="border rounded p-2 bg-gray-50 max-h-80 overflow-y-auto">
                        {selectedDiagnostics.map(diagnosticId => {
                          const diagnostic = diagnosticsList.find(d => d._id === diagnosticId);
                          const diagnosticTests = testsList.filter(t => t.diagnosticId === diagnosticId);
                          const selectedCount = getDiagnosticSelectedCount(diagnosticId, 'tests');

                          if (!diagnostic || diagnosticTests.length === 0) {
                            return (
                              <div key={diagnosticId} className="p-2 text-gray-500 text-sm">
                                No tests available for {diagnostic?.name || 'Unknown'}
                              </div>
                            );
                          }

                          return (
                            <div key={diagnosticId} className="mb-4 border-b border-gray-200 pb-3 last:border-b-0">
                              <div className="font-medium text-sm text-blue-700 mb-2 flex items-center gap-2">
                                <span>{diagnostic.name}</span>
                                <span className="text-xs text-gray-500">
                                  ({selectedCount}/{diagnosticTests.length} selected)
                                </span>
                              </div>
                              <div className="flex flex-col gap-2">
                                {diagnosticTests.map((test) => {
                                  const uniqueKey = `${diagnosticId}_${test._id}`;
                                  const isSelected = selectedTests.includes(uniqueKey);
                                  return (
                                    <label
                                      key={test._id}
                                      className={`flex items-start px-3 py-2 border rounded shadow-sm cursor-pointer hover:bg-gray-50 ${isSelected ? 'bg-blue-50 border-blue-400' : 'bg-white'
                                        }`}
                                    >
                                      <input
                                        type="checkbox"
                                        value={test._id}
                                        checked={isSelected}
                                        onChange={(e) => handleTestChange(e, diagnosticId)}
                                        className="mr-2 mt-1 accent-purple-900"
                                      />
                                      <div className="flex-1">
                                        <div className="font-semibold text-sm">
                                          {test.name}
                                        </div>
                                        <div className="text-xs text-gray-600 mt-1">
                                          <span className="font-medium">Price:</span> ₹{test.price || 0}
                                        </div>
                                        {test.description && (
                                          <div className="text-xs text-gray-500 mt-1">
                                            {test.description.substring(0, 100)}...
                                          </div>
                                        )}
                                        <div className="text-xs text-gray-500 mt-1">
                                          {test.fastingRequired && <span className="mr-2">Fasting Required</span>}
                                          {test.homeCollectionAvailable && <span className="mr-2">Home Collection</span>}
                                        </div>
                                      </div>
                                    </label>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Scans Selection - Grouped by Diagnostic Center */}
              {selectedDiagnostics.length > 0 && assignmentType === 'scans' && (
                <div className="mb-4">
                  <label className="block text-sm mb-2 text-gray-700">
                    Select Scans from Selected Centers
                  </label>

                  {scansList.length === 0 ? (
                    <div className="text-center p-4 text-gray-500 border rounded">
                      No scans available for the selected diagnostic centers.
                    </div>
                  ) : (
                    <>
                      <label className="inline-flex items-center mb-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={allScansSelected()}
                          onChange={handleSelectAllScans}
                          className="mr-2 accent-purple-900"
                        />
                        <span className="text-sm font-medium">Select All Scans</span>
                        <span className="text-xs text-gray-500 ml-2">
                          ({selectedScans.length} selected)
                        </span>
                      </label>

                      <div className="border rounded p-2 bg-gray-50 max-h-80 overflow-y-auto">
                        {selectedDiagnostics.map(diagnosticId => {
                          const diagnostic = diagnosticsList.find(d => d._id === diagnosticId);
                          const diagnosticScans = scansList.filter(s => s.diagnosticId === diagnosticId);
                          const selectedCount = getDiagnosticSelectedCount(diagnosticId, 'scans');

                          if (!diagnostic || diagnosticScans.length === 0) {
                            return (
                              <div key={diagnosticId} className="p-2 text-gray-500 text-sm">
                                No scans available for {diagnostic?.name || 'Unknown'}
                              </div>
                            );
                          }

                          return (
                            <div key={diagnosticId} className="mb-4 border-b border-gray-200 pb-3 last:border-b-0">
                              <div className="font-medium text-sm text-blue-700 mb-2 flex items-center gap-2">
                                <span>{diagnostic.name}</span>
                                <span className="text-xs text-gray-500">
                                  ({selectedCount}/{diagnosticScans.length} selected)
                                </span>
                              </div>
                              <div className="flex flex-col gap-2">
                                {diagnosticScans.map((scan) => {
                                  const uniqueKey = `${diagnosticId}_${scan._id}`;
                                  const isSelected = selectedScans.includes(uniqueKey);
                                  return (
                                    <label
                                      key={scan._id}
                                      className={`flex items-start px-3 py-2 border rounded shadow-sm cursor-pointer hover:bg-gray-50 ${isSelected ? 'bg-blue-50 border-blue-400' : 'bg-white'
                                        }`}
                                    >
                                      <input
                                        type="checkbox"
                                        value={scan._id}
                                        checked={isSelected}
                                        onChange={(e) => handleScanChange(e, diagnosticId)}
                                        className="mr-2 mt-1 accent-purple-900"
                                      />
                                      <div className="flex-1">
                                        <div className="font-semibold text-sm">
                                          {scan.title}
                                        </div>
                                        <div className="text-xs text-gray-600 mt-1">
                                          <span className="font-medium">Price:</span> ₹{scan.price || 0}
                                        </div>
                                        {scan.preparation && (
                                          <div className="text-xs text-gray-500 mt-1">
                                            <span className="font-medium">Preparation:</span> {scan.preparation.substring(0, 100)}...
                                          </div>
                                        )}
                                        {scan.reportTime && (
                                          <div className="text-xs text-gray-500 mt-1">
                                            <span className="font-medium">Report Time:</span> {scan.reportTime}
                                          </div>
                                        )}
                                      </div>
                                    </label>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Age Group Selection */}
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="applyToAllStaff"
                  checked={applyToAllStaff}
                  onChange={() => setApplyToAllStaff((prev) => !prev)}
                  className="accent-purple-900"
                />
                <label htmlFor="applyToAllStaff" className="text-sm font-medium text-gray-700 cursor-pointer">
                  Apply to all users (ignore age group)
                </label>
              </div>

              {!applyToAllStaff && (
                <div className="relative">
                  <div className="flex justify-between items-center mb-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Age Groups
                    </label>
                    <button
                      type="button"
                      onClick={() => setShowAgeGroupManager(true)}
                      className="text-xs text-blue-600 hover:text-blue-800"
                      title="Manage Age Groups"
                    >
                      <FaEdit /> Manage Groups
                    </button>
                  </div>

                  {ageGroups.length > 0 && (
                    <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded">
                      <div className="flex flex-wrap gap-2">
                        {ageGroups.map((ageGroup) => (
                          <span
                            key={ageGroup}
                            className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
                          >
                            {ageGroup}
                            <button
                              type="button"
                              onClick={() => removeAgeGroup(ageGroup)}
                              className="text-blue-600 hover:text-blue-800 text-xs"
                            >
                              <FaTimes />
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="relative">
                    <button
                      type="button"
                      onClick={() => setShowAgeGroupDropdown(!showAgeGroupDropdown)}
                      className="w-full border p-2 rounded-lg text-sm text-left bg-white flex justify-between items-center"
                    >
                      <span>Select Age Groups ({ageGroups.length} selected)</span>
                      <span className={`transform transition-transform ${showAgeGroupDropdown ? 'rotate-180' : ''}`}>
                        ▼
                      </span>
                    </button>

                    {showAgeGroupDropdown && (
                      <div className="absolute top-full left-0 right-0 mt-1 bg-white border rounded-lg shadow-lg z-10 max-h-60 overflow-y-auto">
                        <div className="p-2 border-b bg-gray-50 flex justify-between items-center">
                          <span className="text-sm font-medium">Select Age Groups</span>
                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={selectAllAgeGroups}
                              className="text-xs text-blue-600 hover:text-blue-800"
                            >
                              Select All
                            </button>
                            <button
                              type="button"
                              onClick={clearAllAgeGroups}
                              className="text-xs text-red-600 hover:text-red-800"
                            >
                              Clear All
                            </button>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-1 p-2 max-h-48 overflow-y-auto">
                          {ageGroupOptions.map((ageGroup) => (
                            <label
                              key={ageGroup}
                              className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                checked={ageGroups.includes(ageGroup)}
                                onChange={() => handleAgeGroupChange(ageGroup)}
                                className="accent-blue-600"
                              />
                              <span className="text-sm">{ageGroup} years</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Selection Summary */}
              <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded">
                <h4 className="text-sm font-semibold text-gray-700 mb-2">Selection Summary</h4>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div>
                    <span className="text-gray-600">Diagnostic Centers:</span>
                    <span className="font-medium ml-2">{selectedDiagnostics.length}</span>
                  </div>
                  <div>
                    <span className="text-gray-600">Age Groups:</span>
                    <span className="font-medium ml-2">{applyToAllStaff ? 'All' : ageGroups.length}</span>
                  </div>
                  {assignmentType === 'packages' && (
                    <div>
                      <span className="text-gray-600">Packages Selected:</span>
                      <span className="font-medium ml-2">{selectedPackages.length}</span>
                    </div>
                  )}
                  {assignmentType === 'tests' && (
                    <div>
                      <span className="text-gray-600">Tests Selected:</span>
                      <span className="font-medium ml-2">{selectedTests.length}</span>
                    </div>
                  )}
                  {assignmentType === 'scans' && (
                    <div>
                      <span className="text-gray-600">Scans Selected:</span>
                      <span className="font-medium ml-2">{selectedScans.length}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-between items-center mt-4">
                <button
                  type="button"
                  onClick={closeAssignmentModal}
                  className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg text-sm font-medium hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading.packages || selectedDiagnostics.length === 0 ||
                    (assignmentType === 'packages' && selectedPackages.length === 0) ||
                    (assignmentType === 'tests' && selectedTests.length === 0) ||
                    (assignmentType === 'scans' && selectedScans.length === 0) ||
                    (!applyToAllStaff && ageGroups.length === 0)}
                  className="px-4 py-2 bg-green-900 text-white rounded-lg text-sm font-medium hover:bg-green-800 disabled:opacity-50"
                >
                  {loading.packages ? "Submitting..." : `Assign ${assignmentType.charAt(0).toUpperCase() + assignmentType.slice(1)}`}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Age Group Manager Modal with API Integration */}
      {showAgeGroupManager && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[60]">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[500px]">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-gray-800">
                Manage Age Groups
              </h3>
              <button
                onClick={() => {
                  setShowAgeGroupManager(false);
                  setEditingAgeGroup(null);
                  setNewAgeGroup('');
                }}
                className="text-red-500 hover:text-red-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="mb-6">
              <div className="flex gap-2">
                <input
                  type="text"
                  value={editingAgeGroup || newAgeGroup}
                  onChange={(e) => {
                    if (editingAgeGroup) {
                      setEditingAgeGroup(e.target.value);
                    } else {
                      setNewAgeGroup(e.target.value);
                    }
                  }}
                  placeholder="Enter age group (e.g., 0-5, 6-12, 61+)"
                  className="flex-1 border p-2 rounded-lg text-sm"
                />
                <button
                  onClick={handleSaveAgeGroup}
                  disabled={loading.ageGroups || (!newAgeGroup && !editingAgeGroup)}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
                >
                  {loading.ageGroups ? 'Saving...' : (editingAgeGroup ? 'Update' : 'Add')}
                </button>
                {editingAgeGroup && (
                  <button
                    onClick={() => {
                      setEditingAgeGroup(null);
                      setNewAgeGroup('');
                    }}
                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg text-sm font-medium hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                )}
              </div>
              <p className="text-xs text-gray-500 mt-2">
                Format examples: "0-5 years", "6-12", "13-18", "61+"
              </p>
            </div>

            <div className="border rounded-lg max-h-60 overflow-y-auto">
              <div className="p-3 border-b bg-gray-50 font-medium text-sm flex justify-between items-center">
                <span>Available Age Groups</span>
                <button
                  onClick={fetchAgeGroups}
                  disabled={loading.ageGroups}
                  className="text-xs text-blue-600 hover:text-blue-800"
                >
                  {loading.ageGroups ? 'Loading...' : 'Refresh'}
                </button>
              </div>
              {loading.ageGroups ? (
                <div className="p-4 text-center text-gray-500">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto"></div>
                  <p className="mt-2">Loading age groups...</p>
                </div>
              ) : ageGroupOptions.length === 0 ? (
                <div className="p-4 text-center text-gray-500">
                  No age groups added yet.
                </div>
              ) : (
                <div className="divide-y">
                  {ageGroupOptions.map((ageGroup) => (
                    <div
                      key={ageGroup}
                      className="p-3 flex justify-between items-center hover:bg-gray-50"
                    >
                      <span className="text-sm">{ageGroup} years</span>
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleEditAgeGroup(ageGroup)}
                          disabled={loading.ageGroups}
                          className="text-xs text-blue-600 hover:text-blue-800 px-2 py-1 border border-blue-200 rounded hover:bg-blue-50 disabled:opacity-50"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDeleteAgeGroup(ageGroup)}
                          disabled={loading.ageGroups}
                          className="text-xs text-red-600 hover:text-red-800 px-2 py-1 border border-red-200 rounded hover:bg-red-50 disabled:opacity-50"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="mt-4 flex justify-between">
              <button
                onClick={() => {
                  Swal.fire({
                    title: "Reset Age Groups?",
                    text: "This will restore default age groups. Are you sure?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Reset!",
                    cancelButtonText: "Cancel",
                    reverseButtons: true,
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      const token = localStorage.getItem("authToken");

                      const headers = {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      };

                      try {
                        setLoading((prev) => ({ ...prev, ageGroups: true }));

                        // Fetch existing age groups
                        const response = await axios.get(
                          "https://api.elthiumhealth.com/api/admin/AgeGroups",
                          { headers }
                        );

                        // Delete all existing age groups
                        if (
                          response.data?.success &&
                          Array.isArray(response.data.data)
                        ) {
                          for (const item of response.data.data) {
                            await axios.delete(
                              "https://api.elthiumhealth.com/api/admin/AgeGroups",
                              {
                                data: { ageGroupId: item._id },
                                headers,
                              }
                            );
                          }
                        }

                        // Add default age groups
                        const defaultGroups = [
                          "0-5",
                          "6-12",
                          "13-18",
                          "19-30",
                          "31-45",
                          "46-60",
                          "61+",
                        ];

                        await axios.post(
                          "https://api.elthiumhealth.com/api/admin/AgeGroups",
                          { ageGroups: defaultGroups },
                          { headers }
                        );

                        await fetchAgeGroups();

                        Swal.fire({
                          title: "Success!",
                          text: "Age groups reset to default values.",
                          icon: "success",
                          confirmButtonText: "OK",
                        });
                      } catch (error) {
                        console.error(
                          "Error resetting age groups:",
                          error.response?.data || error.message
                        );

                        Swal.fire({
                          title: "Error!",
                          text:
                            error.response?.data?.message ||
                            "Failed to reset age groups.",
                          icon: "error",
                          confirmButtonText: "OK",
                        });
                      } finally {
                        setLoading((prev) => ({ ...prev, ageGroups: false }));
                      }
                    }
                  });
                }}
                disabled={loading.ageGroups}
                className="text-xs text-gray-600 hover:text-gray-800 disabled:opacity-50"
              >
                Reset to Default
              </button>
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    setShowAgeGroupManager(false);
                    setEditingAgeGroup(null);
                    setNewAgeGroup('');
                  }}
                  className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg text-sm font-medium hover:bg-gray-400"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffList;